import React from 'react';
import Layout from '../../components/Layout';
import ViewListing from './ViewListing';
import NotFound from '../notFound/NotFound';
import { url, fileuploadDir } from '../../config.js';
import createApolloClient from '../../core/createApolloClient/createApolloClient.client';
import gql from 'graphql-tag';
import { track, trackListView } from '../../core/analytics';
import { buildPhotoPath } from '../../helpers/photoutils';
import { getp } from '../../helpers/getProp';

const client = createApolloClient();

const title = 'View Listing';

function renderNotFound() {
  return {
    title,
    component: (
      <Layout>
        <NotFound title={title} />
      </Layout>
    ),
    status: 404,
  };
}

export default {
  path: '/details/:listId/:preview?',
  ssr: false,

  async action({ params }) {
    let listTitle, listDescription, listPhoto, lat, lng;
    const query = gql`
      query GetListMeta($listId: Int!) {
        getListMeta(listId: $listId) {
          id
          title
          description
          isPublished
          category
          category2
        }
      }
    `;

    // From URI
    const listId = params.listId;
    let preview = false;

    if (params.preview) {
      preview = true;
    }

    if (listId === undefined || isNaN(listId)) {
      console.log('No list id available', listId);
      renderNotFound();
      return;
    }

    // const resp = await client.query({
    //   query,
    //   variables: { listId, preview },
    //   fetchPolicy: 'network-only',
    // });
    const resp = {}

    const { data } = resp;
    // if (data && data.getListMeta) {
    //   if (!data.getListMeta.isPublished && !preview) {
    //     renderNotFound();
    //   } else {
    //     const meta = data.getListMeta;
    //     listTitle = `Rent a ${meta.title} from ${getp(
    //       meta,
    //       'user.profile.firstName',
    //     )} on Yoodlize`;
    //     listDescription = data.getListMeta.description;

    //     if (
    //       data.getListMeta.listPhotos &&
    //       data.getListMeta.listPhotos.length > 0
    //     ) {
    //       listPhoto = buildPhotoPath(
    //         'x_medium',
    //         data.getListMeta.listPhotos[0].name,
    //       );
    //     }
    //   }
    // } else {
    //   console.log('No list Meta', data);
    //   renderNotFound();
    //   return;
    // }

    trackListView(
      listId,
      getp(data, 'getListMeta.category'),
      getp(data, 'getListMeta.category2'),
    );

    return {
      title: listTitle || title,
      description: listDescription || '',
      image: listPhoto || '',
      imageUrl: listPhoto || '',
      component: (
        <Layout>
          <ViewListing
            title={title}
            preview={preview ? 'true' : null}
            lat={getp(data, 'getListMeta.listingAddresses.0.lat')}
            lng={getp(data, 'getListMeta.listingAddresses.0.lng')}
            listId={Number(listId)}
          />
        </Layout>
      ),
    };
  },
};



// WEBPACK FOOTER //
// ./src/routes/viewListing/index.js